import { OMNI_URL } from '../helper'

export const OmniauthTokenGenerate_URL = OMNI_URL + '/token/generate/desktop'
export const OmniauthTokenValidate_URL = OMNI_URL + '/token/validate'
export const OmniauthTokenInvalidate_URL = OMNI_URL + '/token/invalidate'
export const OmniauthTokenRefresh_URL = OMNI_URL + '/token/refresh'
export const OmniauthTokenSendMfa_URL = OMNI_URL + '/token/send-mfa'
export const OmniauthTokenVerifyMfa_URL = OMNI_URL + '/token/verify-mfa'
export const OmniauthUserPracticeProvider_URL = OMNI_URL + '/user/practice_provider'
